import { createAction } from '@reduxjs/toolkit';

import type { IsolatedKey } from 'Addons/fitmentSearch/isolatedKeys';
import type { ServerModel } from 'Modules/serverApi/types.ts';

export const setFitmentSearchResponse = createAction(
  'SET_FITMENT_SEARCH_RESPONSE',
  (
    facets: ServerModel.FacetCategory[],
    isAutoVehicleSelectionDisabled: boolean,
    isPartialMode: boolean,
    isolatedKey: IsolatedKey = null,
  ) => ({
    payload: facets,
    meta: { isAutoVehicleSelectionDisabled, isPartialMode, isolatedKey },
  }),
);

export const setFitmentTableResponse = createAction<ServerModel.FitmentsResponseType>(
  'SET_FITMENT_TABLE_RESPONSE',
);
